import { render, staticRenderFns } from "./hero-section.vue?vue&type=template&id=0d85aa9a&scoped=true"
import script from "./hero-section.vue?vue&type=script&lang=js"
export * from "./hero-section.vue?vue&type=script&lang=js"
import style0 from "./hero-section.vue?vue&type=style&index=0&id=0d85aa9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85aa9a",
  null
  
)

export default component.exports